import { useMemo } from 'react';

/**
 * Animated aurora mesh with slowly rising BTCB coins. Pure CSS keyframes, GPU-cheap, and
 * disabled under prefers-reduced-motion by premium.css.
 */
export function Background({ coins = 9 }: { coins?: number }) {
  const items = useMemo(
    () =>
      Array.from({ length: coins }, (_, index) => ({
        left: `${(index * 97) % 100}%`,
        size: 18 + ((index * 37) % 26),
        delay: `${-((index * 7) % 20)}s`,
        duration: `${22 + ((index * 5) % 14)}s`,
        opacity: 0.14 + ((index * 13) % 10) / 60,
      })),
    [coins],
  );
  return (
    <div className="bg-aurora" aria-hidden>
      <div className="blob b1" />
      <div className="blob b2" />
      <div className="blob b3" />
      <div className="coins">
        {items.map((coin, index) => (
          <span
            key={index}
            className="coin"
            style={{
              left: coin.left,
              width: coin.size,
              height: coin.size,
              animationDelay: coin.delay,
              animationDuration: coin.duration,
              opacity: coin.opacity,
              fontSize: coin.size * 0.6,
            }}
          >
            ₿
          </span>
        ))}
      </div>
      <div className="noise" />
    </div>
  );
}
